import { X } from "lucide-react";
import { createIcon } from "@/components/icons/create-icon";

export const XIcon = createIcon(X);
